import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';

export const useAdminAccountManagementStyles = createStyles(({ token }) => ({
  management: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: ThemeSpaces.SPACE_NORM_20,
    padding: `${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM}px 0 ${ThemeSpaces.SPACE_NORM}px`,

    '.AdminConsoleSideMenu__Item': {
      display: 'flex',
      color: ThemeColors.COLOR_GREY_DARK1,
      fontFamily: ThemeFont.FONT_FAMILY,

      '.AdminConsoleSideMenu__ItemInner': {
        alignSelf: 'stretch',
        flex: '1 1',
        display: 'flex',
        alignItems: 'center',
        color: 'inherit',
      },

      '&.AdminConsoleSideMenu__Item--Level0': {
        height: 34,
        fontSize: token.fontSize,
        fontWeight: 500,
        color: ThemeColors.COLOR_GREY11,

        '.AdminConsoleSideMenu__ItemInner': {
          paddingLeft: ThemeSpaces.SPACE_NORM,
        },
      },

      '&:hover, &.active, &:active': {
        color: token.colorPrimary,
        backgroundColor: 'transparent',
        border: 0,
        boxShadow: 'none',
      },

      '&.disabled': {
        color: ThemeColors.COLOR_GREY6,
        opacity: 0.6,
      },
    },
  },
  sidebar: {
    flex: '0 0 240px',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
}));
